import MealGroups from '../MealGroups/MealGroups';
import MealSizes from '../MealSizes/MealSizes';
import MealsValidationMessages from '../MealsValidationMessages/MealsValidationMessages';
import { localeStore } from 'src/mobx/localesStore';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from 'src/view/components/Controls/CustomTooltip/CustomTooltip';
import Text, { TEXT } from 'src/view/components/Text/Text';

const MealProducts: React.FC = (): JSX.Element => {
  return (
    <div className="d-flex flex-column mt-6">
      <Text
        type={TEXT.SECTION_HEADER}
        text="mc_products_block"
        tooltip={{
          message: localeStore.t('mc_products_block_hint') + localeStore.t('mc_products_block_hint2'),
          duration: TOOLTIP_DURATION.EXTRA_LARGE,
          position: TOOLTIP_POSITION.FIXED,
          maxWidth: 400,
          iconSize: 22,
        }}
      />

      <div className="d-flex flex-column full-height mt-4">
        <MealSizes />
        <MealGroups />
        <MealsValidationMessages />
      </div>
    </div>
  );
};

export default MealProducts;
